<template>
    <v-content class="pa-12">
         <v-layout justify-space-around>
             <v-flex d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                 <span>ข่าวสารทั้งหมด</span>
             </v-flex>
             <v-flex d-flex justify-end align-center>
                 <v-btn color="#3E7662" dark @click="$router.push('/create-news')">
                     <span class="mr-2">สร้างข่าวสาร</span>
                     <v-icon>add_box</v-icon>
                 </v-btn>
             </v-flex>
         </v-layout>
        <!-- Table -->
        <v-layout mt-12>
            <v-flex>
                <form-table
                        :headers="headers"
                        :items="newsList"
                        onViewData
                ></form-table>
            </v-flex>
        </v-layout>
        <!-- Pagination -->
        <v-layout mt-12>
            <v-flex>
                <v-pagination
                        color="#3E7662"
                        :length="paginateNews.last_page"
                        :total-visible="9"
                        @input="getNewsList"
                        v-model="paginateNews.current_page"
                ></v-pagination>
            </v-flex>
        </v-layout>
        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>
    </v-content>
</template>

<script>
    import Swal from 'sweetalert2';
    import { mapState, mapActions } from "vuex";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import FormTable from "../../components/table/FormTable";
    export default {
        name: "AllNews",
        components: {
            FormTable,
            Loading,
        },
        computed: {
            ...mapState({
                user: state => state.Auth.user
            })
        },
        data: () => ({
            paginateNews: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            isLoading: false,
            fullPage: true,
            headers: [
                {text: 'ลำดับ', value: 'number', align: "center", width: '2%',sortable: false},
                { text: 'หัวข้อข่าวสาร', value: 'topicNews',align: "center", width: '20%' },
                { text: 'รายละเอียด', value: 'detail', align: "center",sortable: false, width: '20%' },
                { text: 'วันที่เวลา ที่สร้างข่าวสาร', value: 'date', align: "center" , width: '10%'},
                { text: 'จัดการ', value: 'editAllNews', align: "center", sortable: false, width: '2%'},
            ],
            newsList: []
        }),
        created(){
            // Check Permission Access
          //  if (this.user.currentRole !== 1 && this.user.currentRole !== 2 && this.user.currentRole !== 3 && this.user.currentRole !== 4) {
            //    this.$router.go(-1);
           // }

            this.getNewsList(1);
        },
        methods: {

            getNewsList(page) {
                this.newsList = [];
                this.isLoading = true;
                this.$store.dispatch('News/getNewsList',page).then(res => {
                    let i = 1;
                    res.data.forEach(data => {
                        this.newsList.push({
                            number: i,
                            topicNews: data.topic,
                            detail: data.shortDescription.length <= 150 ? data.shortDescription : data.shortDescription.substring(0,150)+"....",
                            date: data.created_at,
                            id: data.id,
                            linkEdit: 'EditNews',
                            onView: 5,
                        });
                        i++;
                    })
                    this.paginateNews.current_page = res.current_page;
                    this.paginateNews.from = res.from;
                    this.paginateNews.last_page = res.last_page;
                    this.paginateNews.per_page = res.per_page;
                    this.paginateNews.total = res.total;
                    this.paginateNews.to = res.to;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
        }


    }
</script>

<style scoped>

</style>
